import { render, staticRenderFns } from "./rol.vue?vue&type=template&id=b5682492"
import script from "./rol.vue?vue&type=script&lang=js"
export * from "./rol.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports